import React from 'react';

export type DataType = 'date' | 'number' | 'string' | 'link' | 'custom' | 'integer';

export interface columnType {
	name: string;
	title: string;
	type: DataType;
	eventsHandle?: {
		[key: string]: (event: React.MouseEvent<HTMLElement>) => void;
	};
	fieldId: string;
	customValueHandle?: (value: string, record: dataType) => void;
	formatDate?: string;
	sortable?: boolean;
	columnFilter?: {
		type?: FilterType;
		freeText?: boolean;
	};
}

export type Order = 'asc' | 'desc';
export const OrderBy = {
	ACSENDING: 'asc',
	DESENDING: 'desc',
};
export type dataType = Record<string, any>;

export interface tableState {
	sortBy?: string;
	orderBy: Order;
	perPage: number;
	page: number;
	total: number;
	filters: filterList;
}

export const initialTableState: tableState = {
	orderBy: 'desc',
	perPage: 10,
	page: 0,
	total: 0,
	filters: {},
};

export interface EnhancedTableProps {
	onRequestSort: (tableState: tableState, setState: any, property: string) => void;
	order: Order;
	orderBy: string;
	rowCount: number;
	headCells: columnType[];
	tableState: tableState;
	setState: any;
}

export enum FilterType {
	Unique = 'unique',
	Search = 'search',
	DateRange = 'dateRange',
	SameDay = 'sameDay',
}

export interface filterData {
	column: string;
	values: string[];
}

export interface filterItem {
	type: FilterType;
	label: string;
	value?: any;
	handleChange?: any;
}

export type filterList = { [key: string]: filterItem };

export interface filterProps {
	filterList?: filterList;
	data: dataType[];
	handleChange: any;
	tableState: tableState;
	includeSearchBox?: boolean;
	searchColumns?: string[];
}

export interface IServerPaginationConfig {
	total: number;
	hasMore: boolean;
	currentPage: number;
	onPageChange: (page: number) => Promise<void> | void;
	onSortChange?: (sortBy: string, orderBy: Order) => Promise<void> | void;
	isLoading?: boolean;
}
